(() => {
  const mobile = () => matchMedia('(max-width: 768px)').matches;
  let pending;
  let returnButton;
  document.addEventListener('click', event => {
    const shortcut = event.target.closest('[data-fr-filter]');
    if (shortcut && mobile() && window.theme?.FilterDrawer) {
      event.preventDefault();
      event.stopPropagation();
      returnButton = shortcut;
      theme.FilterDrawer.open(null, shortcut);
      const trigger = document.querySelector('#FilterDrawer button[data-collapsible-id="' + shortcut.dataset.frFilter + '"]');
      if (trigger) {
        if (!trigger.classList.contains('is-open')) trigger.click();
        requestAnimationFrame(() => {
          const scroll = document.querySelector('#FilterDrawer .drawer__scrollable');
          scroll.scrollTop += trigger.getBoundingClientRect().top - scroll.getBoundingClientRect().top - 12;
          trigger.focus({preventScroll: true});
        });
      }
    }
    if (event.target.closest('[data-fr-results]')) {
      event.preventDefault();
      theme.FilterDrawer?.close();
    }
  }, true);
  document.addEventListener('input', async event => {
    if (!mobile() || !event.target.matches('#FilterDrawer .filter-form input[type="checkbox"]')) return;
    event.stopImmediatePropagation();
    const form = event.target.closest('form');
    const section = form.closest('[data-section-id]');
    if (!section) return;
    const params = new URLSearchParams(new FormData(form));
    const sort = document.querySelector('#SortBy');
    if (sort?.value) params.set('sort_by', sort.value);
    const url = new URL(location.href);
    url.search = params.toString();
    pending?.abort();
    const controller = new AbortController();
    pending = controller;
    const footer = document.querySelector('[data-fr-results]');
    if (footer) {
      footer.disabled = true;
      footer.textContent = footer.dataset.loading;
    }
    const inputName = event.target.name;
    const inputValue = event.target.value;
    const requestUrl = new URL(url);
    requestUrl.searchParams.set('section_id', section.dataset.sectionId);
    try {
      const response = await fetch(requestUrl, {signal: controller.signal});
      if (!response.ok) throw new Error('Filter response failed');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (controller.signal.aborted) return;
      const next = doc.getElementById('CollectionAjaxContent');
      const current = document.getElementById('CollectionAjaxContent');
      if (!next || !current) throw new Error('Filter content missing');
      const drawer = document.getElementById('FilterDrawer');
      const isOpen = theme.FilterDrawer?.isOpen;
      const scrollTop = drawer.querySelector('.drawer__scrollable').scrollTop;
      drawer.querySelectorAll('button.collapsible-trigger.is-open').forEach(trigger => {
        next.querySelectorAll('[data-collapsible-id="' + trigger.dataset.collapsibleId + '"]').forEach(el => {
          el.classList.add('is-open');
          if (el.classList.contains('collapsible-content')) el.style.height = 'auto';
          else el.setAttribute('aria-expanded', 'true');
        });
      });
      theme.FilterDrawer?.unbindEvents();
      theme.a11y.removeTrapFocus({container: drawer, namespace:'drawer_focus'});
      current.innerHTML = next.innerHTML;
      history.pushState({}, '', url);
      theme.sections.reinit('collection-grid');
      theme.reinitProductGridItem();
      if (isOpen) {
        const source = returnButton?.dataset.frFilter;
        const focusReturn = source ? document.querySelector('[data-fr-filter="' + source + '"]') : document.querySelector('.js-drawer-open-collection-filters');
        theme.FilterDrawer.open(null, focusReturn);
        const newDrawer = document.getElementById('FilterDrawer');
        newDrawer.querySelector('.drawer__scrollable').scrollTop = scrollTop;
        const input = Array.from(newDrawer.querySelectorAll('input')).find(el => el.name === inputName && el.value === inputValue);
        input?.focus({preventScroll:true});
      }
      document.dispatchEvent(new CustomEvent('collection:reloaded'));
    } catch (error) {
      if (error.name !== 'AbortError') location.assign(url);
    }
  }, true);
})();